import { CoreView } from '@/components/Theme/Core/CoreView';
import { withStyles } from '@/components/Theme/Core/withStyles';
import { motify } from 'moti';

export const ThemeMotiRow = withStyles(motify(CoreView)(), {style: {flexDirection: 'row'}, type: 'ThemeRow'});